// Client portal → E-Editions (2026-10-27). Champion Media, Times Leader and PAW users upload an
// edition's pages here; they only ever see their own papers. Backend: src/eedition.js.
import { useState, useEffect, useCallback } from "react";
import { Newspaper } from "lucide-react";
import { PORTAL_API } from "../api";
import EEditionUpload, { EditionList } from "../components/EEditionUpload";

const CARD = { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12, padding: 20 };

export default function PortalEEditions({ branding }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(() => {
    PORTAL_API.get("/portal/eeditions").then((r) => setData(r.data)).catch((e) => setError(e?.response?.data?.error || "Couldn't load your papers."));
  }, []);
  useEffect(() => { load(); }, [load]);
  const pal = { text: "#f1f5f9", muted: "rgba(255,255,255,0.62)", faint: "rgba(255,255,255,0.4)", border: "rgba(255,255,255,0.12)", input: "#1e293b",
    accent: branding?.primary_color || "#4f6fff", hover: "rgba(255,255,255,0.05)", ok: "#34d399", danger: "#f87171" };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
        <Newspaper size={22} color={pal.accent} />
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#fff", margin: 0 }}>E-Editions</h1>
      </div>
      {error && <div style={{ ...CARD, color: pal.danger }}>{error}</div>}
      {!data && !error && <div style={{ ...CARD, color: pal.muted }}>Loading…</div>}
      {data && !data.publications.length && <div style={{ ...CARD, color: pal.muted }}>No papers are set up for e-edition uploads on your account yet.</div>}
      {data && data.publications.length > 0 && (
        <>
          <div style={{ ...CARD, marginBottom: 18 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 14 }}>Upload an edition</div>
            <EEditionUpload client={PORTAL_API} base="/portal/eeditions" publications={data.publications} today={data.today} pal={pal} onDone={load} />
          </div>
          <div style={CARD}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 10 }}>Recent editions</div>
            <EditionList runs={data.runs} pal={pal} />
          </div>
        </>
      )}
    </div>
  );
}
